/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Features_SubtitleInputs */

const en_landing_features_subtitle = /** @type {(inputs: Landing_Features_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From resume tailoring to interview prep — one platform, zero compromises on privacy.`)
};

const de_landing_features_subtitle = /** @type {(inputs: Landing_Features_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vom Lebenslauf bis zur Interviewvorbereitung -- eine Plattform, null Kompromisse beim Datenschutz.`)
};

const fr_landing_features_subtitle = /** @type {(inputs: Landing_Features_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du CV à la préparation d'entretien -- une plateforme, zéro compromis sur la vie privée.`)
};

const es_landing_features_subtitle = /** @type {(inputs: Landing_Features_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desde el currículum hasta la preparación de entrevistas -- una plataforma, cero compromisos con la privacidad.`)
};

const it_landing_features_subtitle = /** @type {(inputs: Landing_Features_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dalla creazione del curriculum alla preparazione al colloquio — una piattaforma, zero compromessi sulla privacy.`)
};

const nl_landing_features_subtitle = /** @type {(inputs: Landing_Features_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Van CV-opbouw tot sollicitatiegesprekvoorbereiding — een platform, zonder concessies aan privacy.`)
};

const pl_landing_features_subtitle = /** @type {(inputs: Landing_Features_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Od tworzenia CV po przygotowanie do rozmowy — jedna platforma, zero kompromisów w kwestii prywatności.`)
};

const fi_landing_features_subtitle = /** @type {(inputs: Landing_Features_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansioluettelon rakentamisesta haastatteluvalmistautumiseen — yksi alusta, ei kompromisseja yksityisyydestä.`)
};

const da_landing_features_subtitle = /** @type {(inputs: Landing_Features_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fra CV-opbygning til samtaleforberedelse — én platform, ingen kompromiser på privatlivet.`)
};

const sv_landing_features_subtitle = /** @type {(inputs: Landing_Features_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Från CV-byggande till intervjuförberedelse -- en plattform, inga kompromisser om integritet.`)
};

/**
* | output |
* | --- |
* | "From resume tailoring to interview prep — one platform, zero compromises on privacy." |
*
* @param {Landing_Features_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_features_subtitle = /** @type {((inputs?: Landing_Features_SubtitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Features_SubtitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_features_subtitle(inputs)
	if (locale === "fr") return fr_landing_features_subtitle(inputs)
	if (locale === "es") return es_landing_features_subtitle(inputs)
	if (locale === "it") return it_landing_features_subtitle(inputs)
	if (locale === "nl") return nl_landing_features_subtitle(inputs)
	if (locale === "pl") return pl_landing_features_subtitle(inputs)
	if (locale === "fi") return fi_landing_features_subtitle(inputs)
	if (locale === "da") return da_landing_features_subtitle(inputs)
	if (locale === "sv") return sv_landing_features_subtitle(inputs)
	return en_landing_features_subtitle(inputs)
});